module.exports = __webpack_public_path__ + "static/media/foldingChair.4a45f7ca.svg";